import React, { useEffect, useState, useMemo } from "react";
import { Col, Label, Row } from "reactstrap";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import {
  OrderPersonType,
  PaymentMethod,
} from "../../../../dummyData/dummyData";
import ControlledSelect from "../../../../components/ControlledSelect";
import ControlledDateSelector from "../../../../components/ControlledDateSelector";
import ControlledSearch from "../../../../components/ControlledSearch";
import {
  useGetCartSearchResultsMutation,
  useGetOrganizationSearchResultsMutation,
  useGetUserSearchResultsMutation,
  useLazyCheckDeliveryLocationQuery,
  useGetCustomerDetailsByIdMutation,
} from "../../../../redux/services/orderService";
import ControlledCheckBoxField from "../../../../components/ControlledCheckBoxField";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faMapMarkerAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import "./index.css";
import { useSelector } from "react-redux";
import ControlledToggleSwitch from "../../../../components/ControlledToggleSwitch";
import DeliveryAddressModal, { AddressItem } from "../../../../components/DeliveryAddressModal";
import { useLazyGetPromotionListQuery } from "../../../../redux/services/promotionService";
import ButtonComponent from "../../../../components/ButtonComponent";

interface CartPersonDetailsStepProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
  scheduledOrderWatcher: boolean;
  setUserCreationMode: (isNewUser: boolean) => void;
  orderByWatcher: any;
  cartPersonWatcher: any;
  paymentMethodWatcher: any;
  customerWatcher: any;
  setIsNewCustomer?: any;
  isNewCustomer?: boolean;
  isCanChangeOrderBy: boolean;
  menus?: any;
  isTentativeOrder: boolean;
  onScheduledOrderChange: (details: {
    isScheduledOrder: boolean;
    orderTimeSlot: string | null;
  }) => void;
  onDeliveryValidationChange?: (isValid: boolean, isChecking: boolean) => void;
  onResetDeliveryStates?: () => void;
  resetTrigger?: number;
  onlinePaymentReferenceWatcher?: any;
  deliveryInstructionsWatcher?: any;
  orderNoteWatcher?: any;
  packingNoteWatcher?: any;
  paymentNoteWatcher?: any;
  organizationWatcher?: any;
  deliveryContactNameWatcher?: any;
  promotionCodeWatcher?: any;
  enableManualDeliveryFeeWatcher?: boolean;
  manualDeliveryFeeWatcher?: number;
  manualDeliveryFeeError?: string;
  enableManualDiscountWatcher?: boolean;
  manualDiscountWatcher?: number;
  manualDiscountError?: string;
  suppressMapAutoOpen?: React.MutableRefObject<boolean>;
  reorderInitialAddress?: any;
  isReorderPrefill?: React.MutableRefObject<boolean>;
}

const CartPersonDetailsStep: React.FC<CartPersonDetailsStepProps> = ({
  control,
  watch,
  setValue,
  scheduledOrderWatcher,
  setUserCreationMode,
  orderByWatcher,
  cartPersonWatcher,
  customerWatcher,
  paymentMethodWatcher,
  isNewCustomer,
  setIsNewCustomer,
  isCanChangeOrderBy,
  onScheduledOrderChange,
  isTentativeOrder,
  onDeliveryValidationChange,
  onResetDeliveryStates,
  resetTrigger,
  organizationWatcher,
  enableManualDeliveryFeeWatcher,
  manualDeliveryFeeWatcher,
  manualDeliveryFeeError,
  enableManualDiscountWatcher,
  manualDiscountWatcher,
  manualDiscountError,
  packingNoteWatcher,
  paymentNoteWatcher,
  suppressMapAutoOpen,
  reorderInitialAddress,
  isReorderPrefill,
}) => {
  const selectedRestaurantId = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );
  const selectedRestaurantData = useSelector((state: any) => state.restaurant.selectedRestaurantDetails);
  const restaurantState = useSelector((state: any) => state.restaurant);

  // Transform backend delivery time slots to required format
  // const deliveryTimeSlots = useMemo(() => {
  //   const backendSlots = selectedRestaurantData?.deliveryTimeSlotsAdmin;
  //   if (!backendSlots || !Array.isArray(backendSlots)) {
  //     return [];
  //   }

  //   return backendSlots.map((slot: string) => {
  //     // Convert "12:00 PM - 12:30 PM" to "12:00-12:30" format
  //     const timeRegex = /(\d{1,2}:\d{2})\s*(AM|PM)\s*-\s*(\d{1,2}:\d{2})\s*(AM|PM)/i;
  //     const match = slot.match(timeRegex);

  //     if (match) {
  //       const [, startTime, startPeriod, endTime, endPeriod] = match;

  //       // Convert to 24-hour format for value
  //       const convertTo24Hour = (time: string, period: string) => {
  //         const [hours, minutes] = time.split(':');
  //         let hour24 = parseInt(hours);

  //         if (period.toUpperCase() === 'PM' && hour24 !== 12) {
  //           hour24 += 12;
  //         } else if (period.toUpperCase() === 'AM' && hour24 === 12) {
  //           hour24 = 0;
  //         }

  //         return `${hour24.toString().padStart(2, '0')}:${minutes}`;
  //       };

  //       const startTime24 = convertTo24Hour(startTime, startPeriod);
  //       const endTime24 = convertTo24Hour(endTime, endPeriod);

  //       return {
  //         value: `${startTime24}-${endTime24}`,
  //         label: slot
  //       };
  //     }

  //     // Fallback if regex doesn't match
  //     return {
  //       value: slot.replace(/\s/g, '').toLowerCase(),
  //       label: slot
  //     };
  //   });
  // }, [selectedRestaurantData?.deliveryTimeSlotsAdmin]);
  const deliveryTimeSlots = useMemo(() => {
    // Try to get delivery time slots from selectedRestaurantData
    let backendSlots = selectedRestaurantData?.deliveryTimeSlotsAdmin || restaurantState?.data?.deliveryTimeSlotsAdmin;

    // If not available, try to get from restaurant state as backup
    if (!backendSlots && (restaurantState?.selectedRestaurantDetails?.deliveryTimeSlotsAdmin || restaurantState?.data?.deliveryTimeSlotsAdmin)) {
      backendSlots = restaurantState.selectedRestaurantDetails.deliveryTimeSlotsAdmin || restaurantState.data.deliveryTimeSlotsAdmin;
    }

    if (!backendSlots || !Array.isArray(backendSlots)) {
      console.warn("No delivery time slots found, using default slots");
      // Return default time slots if none are available
      return [
        { value: "10:00-10:30", label: "10:00 AM - 10:30 AM" },
        { value: "10:30-11:00", label: "10:30 AM - 11:00 AM" },
        { value: "11:00-11:30", label: "11:00 AM - 11:30 AM" },
        { value: "11:30-12:00", label: "11:30 AM - 12:00 PM" },
        { value: "12:00-12:30", label: "12:00 PM - 12:30 PM" },
        { value: "12:30-13:00", label: "12:30 PM - 1:00 PM" },
        { value: "13:00-13:30", label: "1:00 PM - 1:30 PM" },
        { value: "13:30-14:00", label: "1:30 PM - 2:00 PM" },
      ];
    }

    return backendSlots.map((slot: string) => {
      // Convert "12:00 PM - 12:30 PM" to "12:00-12:30" format
      const timeRegex = /(\d{1,2}:\d{2})\s*(AM|PM)\s*-\s*(\d{1,2}:\d{2})\s*(AM|PM)/i;
      const match = slot.match(timeRegex);

      if (match) {
        const [, startTime, startPeriod, endTime, endPeriod] = match;

        // Convert to 24-hour format for value
        const convertTo24Hour = (time: string, period: string) => {
          const [hours, minutes] = time.split(':');
          let hour24 = parseInt(hours);

          if (period.toUpperCase() === 'PM' && hour24 !== 12) {
            hour24 += 12;
          } else if (period.toUpperCase() === 'AM' && hour24 === 12) {
            hour24 = 0;
          }

          return `${hour24.toString().padStart(2, '0')}:${minutes}`;
        };

        const startTime24 = convertTo24Hour(startTime, startPeriod);
        const endTime24 = convertTo24Hour(endTime, endPeriod);

        return {
          value: `${startTime24}-${endTime24}`,
          label: slot
        };
      }

      // Fallback if regex doesn't match
      return {
        value: slot.replace(/\s/g, '').toLowerCase(),
        label: slot
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRestaurantData?.deliveryTimeSlotsAdmin, restaurantState?.data?.deliveryTimeSlotsAdmin]);

  const pickupTimeSlots = useMemo(() => {
    let backendSlots = selectedRestaurantData?.pickupTimeSlotsAdmin || restaurantState?.data?.pickupTimeSlotsAdmin;

    if (!backendSlots && (restaurantState?.selectedRestaurantDetails?.pickupTimeSlotsAdmin || restaurantState?.data?.pickupTimeSlotsAdmin)) {
      backendSlots = restaurantState.selectedRestaurantDetails.pickupTimeSlotsAdmin || restaurantState.data.pickupTimeSlotsAdmin;
    }

    if (!backendSlots || !Array.isArray(backendSlots)) {
      console.warn("No pickup time slots found, using default slots");
      // Return default time slots if none are available
      return [
        { value: "10:00-10:30", label: "10:00 AM - 10:30 AM" },
        { value: "10:30-11:00", label: "10:30 AM - 11:00 AM" },
        { value: "11:00-11:30", label: "11:00 AM - 11:30 AM" },
        { value: "11:30-12:00", label: "11:30 AM - 12:00 PM" },
        { value: "12:00-12:30", label: "12:00 PM - 12:30 PM" },
        { value: "12:30-13:00", label: "12:30 PM - 1:00 PM" },
        { value: "13:00-13:30", label: "1:00 PM - 1:30 PM" },
        { value: "13:30-14:00", label: "1:30 PM - 2:00 PM" },
      ];
    }

    return backendSlots.map((slot: string) => {
      // Convert "12:00 PM - 12:30 PM" to "12:00-12:30" format
      const timeRegex = /(\d{1,2}:\d{2})\s*(AM|PM)\s*-\s*(\d{1,2}:\d{2})\s*(AM|PM)/i;
      const match = slot.match(timeRegex);

      if (match) {
        const [, startTime, startPeriod, endTime, endPeriod] = match;

        // Convert to 24-hour format for value
        const convertTo24Hour = (time: string, period: string) => {
          const [hours, minutes] = time.split(':');
          let hour24 = parseInt(hours);

          if (period.toUpperCase() === 'PM' && hour24 !== 12) {
            hour24 += 12;
          } else if (period.toUpperCase() === 'AM' && hour24 === 12) {
            hour24 = 0;
          }

          return `${hour24.toString().padStart(2, '0')}:${minutes}`;
        };

        const startTime24 = convertTo24Hour(startTime, startPeriod);
        const endTime24 = convertTo24Hour(endTime, endPeriod);

        return {
          value: `${startTime24}-${endTime24}`,
          label: slot
        };
      }

      // Fallback if regex doesn't match
      return {
        value: slot.replace(/\s/g, '').toLowerCase(),
        label: slot
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRestaurantData?.pickupTimeSlotsAdmin, restaurantState?.data?.pickupTimeSlotsAdmin]);

  const [searchKey, setSearchKey] = useState(0);
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [organizationOptions, setOrganizationOptions] = useState<any>([]);
  const [cartOptions, setCartOptions] = useState<any>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSearching, setIsSearching] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isAddressVerifying, setIsAddressVerifying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [disableAddCusomButton, setDisableAddCusomButton] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<AddressItem | null>(null);
  const [savedAddresses, setSavedAddresses] = useState<AddressItem[]>([]);
  const [deliveryValidation, setDeliveryValidation] = useState<{
    isValid: boolean | null;
    isChecking: boolean;
    error: string | null;
  }>({
    isValid: null,
    isChecking: false,
    error: null,
  });
  const [phoneValidationError, setPhoneValidationError] = useState<string>("");
  const [isPhoneValid, setIsPhoneValid] = useState<boolean>(false);
  const [phoneValue, setPhoneValue] = useState<string>("");
  const [deliveryPhoneValidationError, setDeliveryPhoneValidationError] = useState<string>("");
  const [isDeliveryPhoneValid, setIsDeliveryPhoneValid] = useState<boolean>(false);
  const [deliveryPhoneValue, setDeliveryPhoneValue] = useState<string>("");
  const [emailValue, setEmailValue] = useState<string>("");
  const [emailValidationError, setEmailValidationError] = useState<string>("");
  const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
  const [promotionOptions, setPromotionOptions] = useState<any>([]);
  const [promotionLoading, setPromotionLoading] = useState(false);
  const [isLoadingCustomerAddresses, setIsLoadingCustomerAddresses] = useState(false);

  const [triggerCartSearchList] = useGetCartSearchResultsMutation();
  const [triggerUserSearchList] = useGetUserSearchResultsMutation();
  const [triggerOrganizationSearchList] = useGetOrganizationSearchResultsMutation();
  const [triggerCartList] = useGetCartSearchResultsMutation();
  const [checkDeliveryLocation] = useLazyCheckDeliveryLocationQuery();
  const [triggerGetPromotionList] = useLazyGetPromotionListQuery();
  const [getCustomerDetailsById] = useGetCustomerDetailsByIdMutation();

  // Check delivery location function
  const checkDeliveryLocationValidity = async (address: AddressItem) => {
    const MySwal = withReactContent(Swal);
    setIsAddressVerifying(true);
    if (!address.latitude || !address.longitude || !selectedRestaurantId) {
      setDeliveryValidation({
        isValid: false,
        isChecking: false,
        error: "Invalid address coordinates",
      });
      return false;
    }

    setDeliveryValidation({
      isValid: null,
      isChecking: true,
      error: null,
    });

    try {
      const response = await checkDeliveryLocation({
        point: {
          latitude: address.latitude,
          longitude: address.longitude,
        },
        restaurantId: selectedRestaurantId,
      }).unwrap();

      const isValid = response.isInsideDeliveryZone;

      if (!isValid) {
        // Show confirmation popup for addresses outside delivery zone
        const result = await MySwal.fire({
          title: "Outside Delivery Zone",
          text: "This location is outside the supported delivery zone. Do you want to set this as the delivery location?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, use this address",
          cancelButtonText: "No, choose another address",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          customClass: {
            confirmButton: "btn btn-danger me-2",
            cancelButton: "btn btn-secondary me-2",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          // User confirmed to use the address despite being outside delivery zone
          setDeliveryValidation({
            isValid: true, // Allow the address to be used
            isChecking: false,
            error: null,
          });
          toast.success("Delivery location verified successfully!");
          setIsAddressVerifying(false);
          return true;
        } else {
          // User chose not to use the address
          setDeliveryValidation({
            isValid: false,
            isChecking: false,
            error: "Address outside delivery zone - not selected",
          });
          setSelectedAddress(null);
          setValue("deliveryAddress", null);
          setIsAddressVerifying(false);
          return false;
        }
      } else {
        // Address is inside delivery zone
        setDeliveryValidation({
          isValid: true,
          isChecking: false,
          error: null,
        });
        toast.success("Delivery location verified successfully!");
        setIsAddressVerifying(false);
        return true;
      }
    } catch (error) {
      console.error("Delivery location check failed:", error);
      setDeliveryValidation({
        isValid: false,
        isChecking: false,
        error: "Unable to verify delivery location. Please try again.",
      });

      toast.error("Unable to verify delivery location. Please try again.");
      // Clear the delivery address when verification fails
      setSelectedAddress(null);
      setValue("deliveryAddress", null);
      setIsAddressVerifying(false);
      return false;
    }
  };

  useEffect(() => {
      if (cartPersonWatcher && cartPersonWatcher.value) {
        const selectedOption = {
          value: cartPersonWatcher?.value,
          label: cartPersonWatcher?.label,
          email: cartPersonWatcher?.email,
          phoneNumber: cartPersonWatcher?.phoneNumber,
        };
        setCartOptions((prevOptions: any) => {
          const alreadyExists = prevOptions.some((o: any) => o.value === selectedOption.value);
          return alreadyExists ? prevOptions : [selectedOption, ...prevOptions];
        });
      }
    }, [cartPersonWatcher]);

    useEffect(() => {
      const cartValue = watch("cart");
      if (cartValue && cartValue.value) {
        const selectedOption = {
          value: cartValue.value,
          label: cartValue.label,
        };
        setCartOptions((prevOptions: any) => {
          const alreadyExists = prevOptions.some((o: any) => o.value === selectedOption.value);
          return alreadyExists ? prevOptions : [selectedOption, ...prevOptions];
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch("cart")]);

    useEffect(() => {
      if (customerWatcher && customerWatcher.value) {
        const selectedOption = {
          value: customerWatcher.value,
          label: customerWatcher.label,
          email: customerWatcher.email,
          phoneNumber: customerWatcher.phoneNumber,
          displayName: customerWatcher.displayName || customerWatcher.label,
        };
        setCustomerOptions((prevOptions: any) => {
          const alreadyExists = prevOptions.some((o: any) => o.value === selectedOption.value);
          return alreadyExists ? prevOptions : [selectedOption, ...prevOptions];
        });
      }
    }, [customerWatcher]);

    useEffect(() => {
      if (organizationWatcher && typeof organizationWatcher === "object" && organizationWatcher.value) {
        const selectedOption = {
          value: organizationWatcher.value,
          label: organizationWatcher.label,
          displayName: organizationWatcher.displayName || organizationWatcher.label,
          phoneNumber: organizationWatcher.phoneNumber,
        };
        setOrganizationOptions((prevOptions: any) => {
          const alreadyExists = prevOptions.some((o: any) => o.value === selectedOption.value);
          return alreadyExists ? prevOptions : [selectedOption, ...prevOptions];
        });
      }
    }, [organizationWatcher]);

    useEffect(() => {
      if (resetTrigger && resetTrigger > 0) {
        resetDeliveryStates();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetTrigger]);

    useEffect(() => {
      if (!reorderInitialAddress) return;
      setSelectedAddress(reorderInitialAddress);
      setSavedAddresses([reorderInitialAddress]);
    }, [reorderInitialAddress]);

    // Seed organization options for reorder prefill
    useEffect(() => {
      if (!isReorderPrefill?.current) return;
      const org = (watch as any)("organization");
      if (org && org.value) {
        setOrganizationOptions((prev: any) => {
          const exists = prev.some((o: any) => o.value === org.value);
          return exists ? prev : [org, ...prev];
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReorderPrefill]);

    // Sync the "phoneNumber" form field → phoneValue display state during reorder prefill.
    // setValue("phoneNumber", ...) in CreateOrder sets the form value but NOT this local state.
    useEffect(() => {
      if (!isReorderPrefill?.current) return;
      const formPhone = watch("phoneNumber");
      if (formPhone && !phoneValue) {
        const normalized = normalizePhoneNumber(formPhone);
        setPhoneValue(formatPhoneForDisplay(normalized));
        const validation = validateSriLankanPhoneNumber(normalized);
        setPhoneValidationError(validation.isValid ? "" : (validation.message || "Invalid phone number"));
        setIsPhoneValid(validation.isValid);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch("phoneNumber"), isReorderPrefill]);

    // Sync the "deliveryContactPhoneNumber" form field → deliveryPhoneValue display state during reorder prefill.
    // setValue("deliveryContactPhoneNumber", ...) in CreateOrder sets the form value but NOT this local state.
    useEffect(() => {
      if (!isReorderPrefill?.current) return;
      const formDeliveryPhone = watch("deliveryContactPhoneNumber");
      if (formDeliveryPhone && !deliveryPhoneValue) {
        const normalized = normalizePhoneNumber(formDeliveryPhone);
        setDeliveryPhoneValue(formatPhoneForDisplay(normalized));
        const validation = validateSriLankanPhoneNumber(normalized);
        setDeliveryPhoneValidationError(validation.isValid ? "" : (validation.message || "Invalid phone number"));
        setIsDeliveryPhoneValid(validation.isValid);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch("deliveryContactPhoneNumber"), isReorderPrefill]);

  const validateUserSearchParams = (params: string) => {
    const queryPattern = /query=[^&]+/;
    const filtersPattern = /filters=userType:Customer/;

    const hasQuery = queryPattern.test(params);
    const hasFilters = filtersPattern.test(params);

    if (!hasQuery) {
      throw new Error(
        "Invalid search params for User: Missing 'query' parameter."
      );
    }
    if (!hasFilters) {
      throw new Error(
        "Invalid search params for User: 'filters' must include 'userType:Customer'."
      );
    }

    return true;
  };

  useEffect(() => {
    onScheduledOrderChange({
      isScheduledOrder: !isTentativeOrder && watch("isScheduledOrder"),
      orderTimeSlot: !isTentativeOrder ? watch("orderTimeSlot")?.value || null : null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("isScheduledOrder"), watch("orderTimeSlot"), isTentativeOrder]);

  const fetchCarts = async () => {
      setCartLoading(true);
      try {
        const response = await triggerCartList({ params: "" });
        if (response && "data" in response) {
          const optionsList = response.data?.hits?.map((item: any) => ({
            value: item.cartId,
            label: item.displayName,
          }));
          // Merge with existing options so pre-filled reorder values are preserved
          setCartOptions((prev: any) => {
            const merged = [...(optionsList || [])];
            prev.forEach((existing: any) => {
              if (!merged.some((o: any) => o.value === existing.value)) {
                merged.unshift(existing);
              }
            });
            return merged;
          });
        }
    } catch (error) {
      toast.error("Error fetching carts");
      console.error("Error fetching carts:", error);
    } finally {
      setCartLoading(false);
    }
  };

  useEffect(() => {
      if (orderByWatcher?.value === "User" || orderByWatcher?.value === "CartPerson") {
        fetchCarts();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderByWatcher]);

  // Effect to handle manual delivery fee checkbox state change
  useEffect(() => {
    if (isReorderPrefill?.current) return;
    if (!watch("enableManualDeliveryFee")) {
      setValue("manualDeliveryFee", undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("enableManualDeliveryFee"), setValue, isReorderPrefill]);

  // Effect to handle manual discount checkbox state change
  useEffect(() => {
    if (isReorderPrefill?.current) return;
    if (!watch("enableManualDiscount")) {
      setValue("manualDiscount", undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("enableManualDiscount"), setValue, isReorderPrefill]);

  // Effect to handle discount type change - clear value if switching to percentage and current value > 100
  useEffect(() => {
    const discountType = watch("manualDiscountType")?.value;
    const currentDiscount = watch("manualDiscount");

    if (discountType === "Percentage" && currentDiscount && currentDiscount > 100) {
      setValue("manualDiscount", undefined);
      toast.info("Discount value cleared because percentage cannot exceed 100%");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("manualDiscountType"), setValue]);

  const handleCartSelect = (selectedOption: any) => {
    setValue("cart", selectedOption);
  };

  const handleCustomerSearch = async (inputValue: string) => {
    setLoading(true);
    setIsSearching(true);

    if (inputValue.length > 1) {
      try {
        const params = `query=${inputValue}&filters=userType:Customer`;
        validateUserSearchParams(params);
        const response = await triggerUserSearchList({ params });

        if (response && "data" in response) {
          const optionsList = response.data?.hits?.map((item: any) => ({
            value: item.documentId,
            label: `${item.displayName} ${item.email} ${item.phoneNumber}`,
            email: item.email,
            phoneNumber: item.phoneNumber,
            displayName: item.displayName,
          }));
          setCustomerOptions(optionsList || []);
        }
      } catch (error) {
        toast.error("Error fetching customer results");
        console.error("Error fetching customer results:", error);
      }
    }
    setLoading(false);
    setIsSearching(false);
  };

  const handleOrganizationSearch = async (inputValue: string) => {
    setLoading(true);
    setIsSearching(true);

    if (inputValue.length > 1) {
      try {
        const params = `query=${inputValue}`;
        // validateUserSearchParams(params);
        const response = await triggerOrganizationSearchList({ params });

        if (response && "data" in response) {
          const optionsList = response.data?.hits?.map((item: any) => ({
            value: item.organizationId,
            label: `${item.displayName}`,
            phoneNumber: item?.deliveryPoint?.deliveryContactPhone || item?.phoneNumber || item?.contactNumber || item?.mobile,
            displayName: item.displayName,
            deliveryAddress: item?.deliveryPoint?.deliveryAddress,
            address: item?.deliveryPoint?.deliveryAddress,
            latitude: item?.deliveryPoint?.deliveryLatitude || item?.latitude,
            longitude: item?.deliveryPoint?.deliveryLongitude || item?.longitude,
            deliveryLatitude: item?.deliveryPoint?.deliveryLatitude,
            deliveryLongitude: item?.deliveryPoint?.deliveryLongitude,
            deliveryContactName: item?.deliveryPoint?.deliveryContactName,
          }));
          setOrganizationOptions(optionsList || []);
        }
      } catch (error) {
        toast.error("Error fetching organization results");
        console.error("Error fetching organization results:", error);
      }
    }
    setLoading(false);
    setIsSearching(false);
  };

  const handleCartSearch = async (inputValue: string) => {
    setCartLoading(true);

    if (inputValue.length > 1) {
      try {
        const response = await triggerCartSearchList({ params: `query=${inputValue}` });

        if (response && "data" in response) {
          const optionsList = response.data?.hits?.map((item: any) => ({
            value: item.cartId,
            label: item.displayName,
          }));
          setCartOptions(optionsList || []);
        }
      } catch (error) {
        toast.error("Error fetching cart results");
        console.error("Error fetching cart results:", error);
      }
    }
    setCartLoading(false);
  };

  const handleCustomerInputChange = (inputValue: string) => {
    setIsNewCustomer(false);
    if (inputValue.length > 0) {
      setDisableAddCusomButton(true);
    } else {
      setDisableAddCusomButton(false);
    }

    if (inputValue.length > 2) {
      handleCustomerSearch(inputValue);
    }
  };

  const handleOrganizationInputChange = (inputValue: string) => {
    setIsNewCustomer(false);
    if (inputValue.length > 0) {
      setDisableAddCusomButton(true);
    } else {
      setDisableAddCusomButton(false);
    }

    if (inputValue.length > 2) {
      handleOrganizationSearch(inputValue);
    }
  };

  const handleOrganizationSelect = (selectedOption: any) => {
    if (selectedOption) {
      setValue("organization", selectedOption);
      setValue("organizationId", selectedOption.value);

      // Auto-populate and validate phone number from selected organization
      if (selectedOption.phoneNumber) {
        const normalizedPhone = normalizePhoneNumber(selectedOption.phoneNumber);
        setPhoneValue(formatPhoneForDisplay(normalizedPhone));
        setValue("phoneNumber", normalizedPhone);

        // Validate the existing phone number
        const validation = validateSriLankanPhoneNumber(normalizedPhone);
        if (validation.isValid) {
          setPhoneValidationError("");
          setIsPhoneValid(true);
        } else {
          setPhoneValidationError(validation.message || "Invalid phone number");
          setIsPhoneValid(false);
        }
      } else {
        // Clear phone data if organization doesn't have phone number
        setPhoneValue("");
        setPhoneValidationError("Phone number is required");
        setIsPhoneValid(false);
        setValue("phoneNumber", "");
      }

      // Auto-populate delivery contact name from selected organization
      if (selectedOption.displayName) {
        setValue("deliveryContactName", selectedOption.deliveryContactName);
      }

      // Auto-populate delivery address from selected organization
      if (selectedOption.deliveryAddress || selectedOption.address) {
        const organizationAddress = {
          address: selectedOption.deliveryAddress || selectedOption.address,
          latitude: selectedOption.latitude || selectedOption.deliveryLatitude,
          longitude: selectedOption.longitude || selectedOption.deliveryLongitude,
          tag: selectedOption.displayName || "Organization Address"
        };

        // Set the delivery address
        setSelectedAddress(organizationAddress);
        setValue("deliveryAddress", organizationAddress);

        // If coordinates are available, validate the delivery location
        if (organizationAddress.latitude && organizationAddress.longitude && isDeliveryOrderWatcher) {
          checkDeliveryLocationValidity(organizationAddress);
        }
      }
    } else {
      setValue("organization", null);
      setValue("organizationId", null);
      // Clear phone data when organization is deselected
      setPhoneValue("");
      setPhoneValidationError("");
      setIsPhoneValid(false);
      setValue("phoneNumber", "");
      // Clear delivery contact name when organization is deselected
      setValue("deliveryContactName", "");
      // Clear delivery address when organization is deselected
      setSelectedAddress(null);
      setValue("deliveryAddress", null);
    }
  };

  const handleCartInputChange = (inputValue: string) => {
    if (inputValue.length > 2) {
      handleCartSearch(inputValue);
    }
  };

  const fetchPromotions = async () => {
    setPromotionLoading(true);
    try {
      const response = await triggerGetPromotionList(selectedRestaurantId);
      if (response && "data" in response) {
        // Filter promotions based on status and special handling for "Free Promotion"
        const filteredPromotions = response.data?.filter((promotion: any) => {
          const promotionName = promotion.name || promotion.displayName || promotion.title;

          // For "Free Promotion", only check status
          if (promotionName === "Free Promotion") {
            return promotion.status === "Active";
          }

          // For other promotions, check status, isPublic, and isActive
          return promotion.status === "Active" && promotion.isPublic === true && promotion.isActive === true;
        });

        const optionsList = filteredPromotions?.map((promotion: any) => ({
          value: promotion.id || promotion.promotionId,
          label: promotion.name || promotion.displayName || promotion.title,
          ...promotion,
        }));
        setPromotionOptions(optionsList || []);
      }
    } catch (error) {
      toast.error("Error fetching promotions");
      console.error("Error fetching promotions:", error);
    } finally {
      setPromotionLoading(false);
    }
  };

  const fetchCustomerAddresses = async (customerId: string) => {
    setIsLoadingCustomerAddresses(true);
    // Open modal immediately to show loading indicator
    setShowAddressModal(true);

    try {
      const response = await getCustomerDetailsById(customerId);

      if (response && "data" in response) {
        const customerData = response.data;

        // Only process addresses for non-anonymous customers
        if (!customerData.isAnonymousUser && customerData.addresses && Array.isArray(customerData.addresses)) {
          // Transform addresses to AddressItem format
          const formattedAddresses: AddressItem[] = customerData.addresses.map((addr: any) => ({
            address: addr.address,
            latitude: addr.location?.latitude,
            longitude: addr.location?.longitude,
            tag: addr.tag || "Saved Address",
            id: addr.id,
            isSelected: addr.isSelected || false,
          }));

          // Update saved addresses
          setSavedAddresses(formattedAddresses);

          // If only one address, auto-select it
          if (formattedAddresses.length === 1) {
            const singleAddress = formattedAddresses[0];
            setSelectedAddress(singleAddress);
            setValue("deliveryAddress", singleAddress);

            // Validate delivery location if coordinates are available
            if (singleAddress.latitude && singleAddress.longitude && isDeliveryOrderWatcher) {
              checkDeliveryLocationValidity(singleAddress);
            }

            toast.success("Customer's saved address loaded and selected.");
            // Close modal after a brief delay so user can see the address
            setTimeout(() => {
              setShowAddressModal(false);
            }, 1500);
          } else if (formattedAddresses.length > 1) {
            // Multiple addresses - modal is already open, show them
            toast.info(`${formattedAddresses.length} saved addresses found. Please select one.`);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching customer addresses:", error);
      // Don't show error toast as this is not critical - user can still enter address manually
    } finally {
      setIsLoadingCustomerAddresses(false);
    }
  };

  const handleUserSelect = (selectedOption: any) => {
    if (selectedOption.value === "add_new") {
      setIsNewCustomer(true);
      setUserCreationMode(true);
      // Reset all form states for new customer
      resetAllFormStates();
      setValue("phoneNumber", "");
    } else {
      setIsNewCustomer(false);
      setUserCreationMode(false);
      setLoading(false);
      setTimeout(() => {
        setValue("user", selectedOption);
        setValue("email", "");

        // 🔥 For BOTH delivery and pickup orders, pre-populate and validate phone number from selected customer
        if (selectedOption.phoneNumber) {
          const normalizedPhone = normalizePhoneNumber(selectedOption.phoneNumber);
          setPhoneValue(formatPhoneForDisplay(normalizedPhone));
          setValue("phoneNumber", normalizedPhone);

          // Validate the existing phone number
          const validation = validateSriLankanPhoneNumber(normalizedPhone);
          if (validation.isValid) {
            setPhoneValidationError("");
            setIsPhoneValid(true);
          } else {
            setPhoneValidationError(validation.message || "Invalid phone number");
            setIsPhoneValid(false);
          }
        } else {
          // Clear phone data if customer doesn't have phone number
          setPhoneValue("");
          setPhoneValidationError("Phone number is required");
          setIsPhoneValid(false);
          setValue("phoneNumber", "");
        }

        // Fetch customer addresses if it's a delivery order and customer ID is available
        if (isDeliveryOrderWatcher && selectedOption.value) {
          fetchCustomerAddresses(selectedOption.value);
        }
      }, 1000);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (isReorderPrefill?.current) return;
        if (orderByWatcher?.value) {
          setValue("cartPerson", null);
          setValue("user", null);
          setCustomerOptions([]);
          setCartOptions([]);
          setSearchKey((prevKey) => prevKey + 1);
        }
      }, [orderByWatcher, setValue, isReorderPrefill]);

  const handleAddNewButtonClick = () => {
    if (!disableAddCusomButton) {
      setIsNewCustomer(true);
      setUserCreationMode(true);

      // Clear the selected customer and reset the search field
      setValue("user", null);
      setCustomerOptions([]);

      // Reset all form states for new customer
      resetAllFormStates();
      setValue("phoneNumber", "");
      setValue("email", "");

      // Increment search key to force re-render of ControlledSearch component
      setSearchKey((prevKey) => prevKey + 1);
    } else {
      toast.warning("Clear search data");
    }
  };

  // Force delivery mode for organization orders, pickup mode for cart person orders
  useEffect(() => {
    if (orderByWatcher?.value === "Organization") {
      setValue("isDeliveryOrder", true);
    } else if (orderByWatcher?.value === "CartPerson") {
      setValue("isDeliveryOrder", false);
    }
  }, [orderByWatcher?.value, setValue]);

  const isDeliveryOrderWatcher = watch("isDeliveryOrder");
  const organizationObjectWatcher = watch("organization");

  useEffect(() => {
      if (!isDeliveryOrderWatcher) {
        // 🔥 Call reset when switching to pickup
        resetDeliveryStates();
      } else {
        // 🔥 When switching to delivery, fetch addresses if customer is already selected
        // Skip auto-opening address modal during reorder pre-fill
        if (suppressMapAutoOpen?.current) return;
        if (customerWatcher?.value && !isNewCustomer && orderByWatcher?.value === "User") {
          fetchCustomerAddresses(customerWatcher.value);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDeliveryOrderWatcher]);

  // Or call it when order type changes
  useEffect(() => {
    if (isReorderPrefill?.current) return;
      if (orderByWatcher?.value) {
        setValue("cartPerson", null);
        setValue("user", null);
        setCustomerOptions([]);
        setCartOptions([]);
        setSearchKey((prevKey) => prevKey + 1);

        // 🔥 Reset organization fields when switching order types
        setValue("organization", null);
        setValue("organizationId", null);

        // 🔥 Reset isNewCustomer state when order type changes
        setIsNewCustomer(false);
        setUserCreationMode(false);

        // 🔥 Reset all form states when order type changes (User/Organization/CartPerson)
        resetAllFormStates();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderByWatcher, setValue]);

  // Fetch promotions when restaurant ID is available
  useEffect(() => {
    if (selectedRestaurantId) {
      fetchPromotions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRestaurantId]);

  const handleAddressSelect = async (address: AddressItem) => {
    let finalAddress = address;

    // If address doesn't have coordinates, try to geocode it
    if (!address.latitude || !address.longitude) {

      if (window.google && window.google.maps) {
        try {
          const geocoder = new window.google.maps.Geocoder();
          const results = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
            geocoder.geocode({ address: address.address }, (results, status) => {
              if (status === "OK" && results) {
                resolve(results);
              } else {
                reject(new Error("Geocoding failed"));
              }
            });
          });

          if (results[0] && results[0].geometry) {
            const location = results[0].geometry.location;
            finalAddress = {
              ...address,
              latitude: location.lat(),
              longitude: location.lng()
            };
          }
        } catch (error) {
          console.warn("Could not geocode address:", address.address);
          toast.error("Unable to get coordinates for this address. Please select from map.");
          return;
        }
      }
    }
    setSelectedAddress(finalAddress);
    setValue("deliveryAddress", finalAddress);
    setShowAddressModal(false);

    // Check delivery location validity if it's a delivery order
    if (isDeliveryOrderWatcher) {
      await checkDeliveryLocationValidity(finalAddress);
    }
    // persist the selected address into local saved addresses (most recent first, dedupe)
    try {
      setSavedAddresses((prev) => {
        const list = [...prev];
        const existsIndex = list.findIndex((a) =>
          (a.latitude !== undefined && a.longitude !== undefined && finalAddress.latitude !== undefined && finalAddress.longitude !== undefined &&
            a.latitude === finalAddress.latitude && a.longitude === finalAddress.longitude) ||
          (a.address === finalAddress.address)
        );
        if (existsIndex !== -1) {
          list.splice(existsIndex, 1);
        }
        list.unshift(finalAddress);
        const limited = list.slice(0, 10);
        try {
          localStorage.setItem("delivery_saved_addresses", JSON.stringify(limited));
        } catch (e) {
          console.warn("Failed to persist saved addresses", e);
        }
        return limited;
      });
    } catch (e) {
      console.warn("Error updating saved addresses", e);
    }
  };

  useEffect(() => {
    if (!isDeliveryOrderWatcher) {
      setDeliveryValidation({
        isValid: null,
        isChecking: false,
        error: null,
      });
      setSelectedAddress(null);
      setValue("deliveryAddress", null);
    }
  }, [isDeliveryOrderWatcher, setValue]);

  useEffect(() => {
    return () => {
      setSelectedAddress(null);
      setDeliveryValidation({
        isValid: null,
        isChecking: false,
        error: null,
      });
    };
  }, []);

  // Add a reset method that can be called externally
  const resetDeliveryStates = () => {
    setSelectedAddress(null);
    setDeliveryValidation({
      isValid: null,
      isChecking: false,
      error: null,
    });

    // Call parent's reset callback
    if (onResetDeliveryStates) {
      onResetDeliveryStates();
    }
  };

  // Separate function to reset all form states (including phone/email)
  const resetAllFormStates = () => {
    resetDeliveryStates();
    setPhoneValue("");
    setPhoneValidationError("");
    setIsPhoneValid(false);
    setDeliveryPhoneValue("");
    setDeliveryPhoneValidationError("");
    setIsDeliveryPhoneValid(false);
    setEmailValue("");
    setEmailValidationError("");
    setIsEmailValid(false);
  };

  useEffect(() => {
    if (onDeliveryValidationChange) {
      const isValid = !isDeliveryOrderWatcher || deliveryValidation.isValid === true;
      const isChecking = isDeliveryOrderWatcher && deliveryValidation.isChecking;
      onDeliveryValidationChange(isValid, isChecking);
    }
  }, [isDeliveryOrderWatcher, deliveryValidation, onDeliveryValidationChange]);

  useEffect(() => {
    // 🔥 Handle phone number for User orders when customer is selected
    if (customerWatcher?.phoneNumber && !isNewCustomer && orderByWatcher?.value === "User") {
      // Set and validate phone number from selected customer for User orders
      const normalizedPhone = normalizePhoneNumber(customerWatcher.phoneNumber);
      setPhoneValue(formatPhoneForDisplay(normalizedPhone));
      setValue("phoneNumber", normalizedPhone);

      const validation = validateSriLankanPhoneNumber(normalizedPhone);
      if (validation.isValid) {
        setPhoneValidationError("");
        setIsPhoneValid(true);
      } else {
        setPhoneValidationError(validation.message || "Invalid phone number");
        setIsPhoneValid(false);
      }
    }
    // 🔥 Handle phone number for Organization orders when organization is selected
        // organizationObjectWatcher = watch("organization") has the full object incl. phoneNumber
        // organizationWatcher prop = watch("organizationId") = raw string ID only
        else if (orderByWatcher?.value === "Organization") {
          const orgPhone = organizationObjectWatcher?.phoneNumber || (organizationWatcher as any)?.phoneNumber;
          if (orgPhone) {
            const normalizedPhone = normalizePhoneNumber(orgPhone);
            setPhoneValue(formatPhoneForDisplay(normalizedPhone));
            setValue("phoneNumber", normalizedPhone);

            const validation = validateSriLankanPhoneNumber(normalizedPhone);
            if (validation.isValid) {
              setPhoneValidationError("");
              setIsPhoneValid(true);
            } else {
              setPhoneValidationError(validation.message || "Invalid phone number");
              setIsPhoneValid(false);
            }
          }
        }
        // Clear phone data when switching to new customer or different order type
        else if (isNewCustomer || (orderByWatcher?.value !== "User" && orderByWatcher?.value !== "Organization")) {
          setPhoneValue("");
          setPhoneValidationError("");
          setIsPhoneValid(false);
          setValue("phoneNumber", "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [customerWatcher, organizationWatcher, organizationObjectWatcher, isNewCustomer, orderByWatcher, setValue]);

  const handleAddressModalOpen = () => {
    setShowAddressModal(true);
  };

  const handleAddressModalClose = () => {
    setShowAddressModal(false);
  };

  // Add at the top of CartPersonDetailsStep component after imports
  const normalizePhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return '';

    // Remove all non-digit characters
    const digitsOnly = phoneNumber.replace(/\D/g, '');

    // Handle different formats
    if (digitsOnly.startsWith('94')) {
      // Remove country code (+94) and return 10-digit local number
      const localNumber = digitsOnly.substring(2);
      return localNumber.length === 9 ? '0' + localNumber : localNumber;
    } else if (digitsOnly.startsWith('0')) {
      // Already in correct format
      return digitsOnly;
    } else if (digitsOnly.length === 9) {
      // Missing leading zero
      return '0' + digitsOnly;
    }

    return digitsOnly;
  };

  const validateSriLankanPhoneNumber = (phoneNumber: string): { isValid: boolean; message?: string } => {
    if (!phoneNumber || phoneNumber.trim() === '') {
      return { isValid: false, message: "Phone number is required" };
    }

    const normalized = normalizePhoneNumber(phoneNumber);

    // Check if it's exactly 10 digits after normalization
    if (!/^\d{10}$/.test(normalized)) {
      return {
        isValid: false,
        message: "Please enter a valid 10-digit phone number"
      };
    }

    // Check if it starts with valid Sri Lankan mobile prefixes
    const validPrefixes = ['070', '071', '072', '074', '075', '076', '077', '078', '011'];
    const prefix = normalized.substring(0, 3);

    if (!validPrefixes.includes(prefix)) {
      return {
        isValid: false,
        message: "Please enter a valid Sri Lankan mobile number (07xx xxx xxx)"
      };
    }

    return { isValid: true };
  };

  const formatPhoneForDisplay = (phoneNumber: string): string => {
    const normalized = normalizePhoneNumber(phoneNumber);
    if (normalized.length === 10) {
      // Format as: 077 123 4567
      return `${normalized.substring(0, 3)} ${normalized.substring(3, 6)} ${normalized.substring(6)}`;
    }
    return phoneNumber;
  };

  // Update the handlePhoneNumberChange function:

  const handlePhoneNumberChange = (value: string) => {
    setPhoneValue(value);

    if (!value || value.trim() === '') {
      setPhoneValidationError("Phone number is required");
      setIsPhoneValid(false);
      setValue("phoneNumber", "");
      return;
    }

    // Only validate if user has typed enough digits (10 or more)
    // This prevents showing errors while user is still typing
    const digitsOnly = value.replace(/\D/g, '');

    if (digitsOnly.length >= 10) {
      const validation = validateSriLankanPhoneNumber(value);

      if (!validation.isValid) {
        setPhoneValidationError(validation.message || "Invalid phone number");
        setIsPhoneValid(false);
      } else {
        setPhoneValidationError("");
        setIsPhoneValid(true);

        // Normalize and set the value
        const normalized = normalizePhoneNumber(value);
        setValue("phoneNumber", normalized);
      }
    } else {
      // Clear error while user is still typing (less than 10 digits)
      setPhoneValidationError("");
      setIsPhoneValid(false);
      setValue("phoneNumber", "");
    }
  };

  // Handle phone number formatting on blur
  const handlePhoneNumberBlur = (value: string) => {
    if (!value || value.trim() === '') {
      setPhoneValidationError("Phone number is required");
      setIsPhoneValid(false);
      setValue("phoneNumber", "");
      return;
    }

    // Always validate on blur (when user finishes typing)
    const validation = validateSriLankanPhoneNumber(value);

    if (!validation.isValid) {
      setPhoneValidationError(validation.message || "Invalid phone number");
      setIsPhoneValid(false);
    } else {
      setPhoneValidationError("");
      setIsPhoneValid(true);

      // Normalize and set the value
      const normalized = normalizePhoneNumber(value);
      setValue("phoneNumber", normalized);

      // Format for display
      const formatted = formatPhoneForDisplay(normalized);
      setPhoneValue(formatted);
    }
  };

  // Add email validation function
  const validateEmail = (email: string): { isValid: boolean; message?: string } => {
    if (!email || email.trim() === '') {
      return { isValid: true };
    }

    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!emailRegex.test(email)) {
      return {
        isValid: false,
        message: "Please enter a valid email address"
      };
    }

    return { isValid: true };
  };

  // Add delivery contact phone number change handler
  const handleDeliveryPhoneNumberChange = (value: string) => {
    setDeliveryPhoneValue(value);

    if (!value || value.trim() === '') {
      setDeliveryPhoneValidationError("");
      setIsDeliveryPhoneValid(false);
      setValue("deliveryContactPhoneNumber", "");
      return;
    }

    // Only validate if user has typed enough digits (10 or more)
    // This prevents showing errors while user is still typing
    const digitsOnly = value.replace(/\D/g, '');

    if (digitsOnly.length >= 10) {
      const validation = validateSriLankanPhoneNumber(value);

      if (!validation.isValid) {
        setDeliveryPhoneValidationError(validation.message || "Invalid phone number");
        setIsDeliveryPhoneValid(false);
      } else {
        setDeliveryPhoneValidationError("");
        setIsDeliveryPhoneValid(true);

        // Normalize and set the value
        const normalized = normalizePhoneNumber(value);
        setValue("deliveryContactPhoneNumber", normalized);
      }
    } else {
      // Clear error while user is still typing (less than 10 digits)
      setDeliveryPhoneValidationError("");
      setIsDeliveryPhoneValid(false);
      setValue("deliveryContactPhoneNumber", "");
    }
  };

  // Handle delivery contact phone number formatting on blur
  const handleDeliveryPhoneNumberBlur = (value: string) => {
    if (!value || value.trim() === '') {
      setDeliveryPhoneValidationError("");
      setIsDeliveryPhoneValid(false);
      setValue("deliveryContactPhoneNumber", "");
      return;
    }

    // Always validate on blur (when user finishes typing)
    const validation = validateSriLankanPhoneNumber(value);

    if (!validation.isValid) {
      setDeliveryPhoneValidationError(validation.message || "Invalid phone number");
      setIsDeliveryPhoneValid(false);
    } else {
      setDeliveryPhoneValidationError("");
      setIsDeliveryPhoneValid(true);

      // Normalize and set the value
      const normalized = normalizePhoneNumber(value);
      setValue("deliveryContactPhoneNumber", normalized);

      // Format for display
      const formatted = formatPhoneForDisplay(normalized);
      setDeliveryPhoneValue(formatted);
    }
  };

  // Add function to copy customer details to delivery contact fields
  const handleUseCustomerDetails = () => {
    let customerName = "";
    let customerPhone = "";

    // Get customer name based on order type
    if (orderByWatcher?.value === "User") {
      if (isNewCustomer) {
        customerName = watch("userName") || "";
      } else {
        customerName = customerWatcher?.displayName || customerWatcher?.label || "";
      }
    } else if (orderByWatcher?.value === "Organization") {
      customerName = organizationWatcher?.displayName || organizationWatcher?.label || "";
    }

    // Get customer phone number
    customerPhone = phoneValue || "";

    // Set delivery contact fields
    if (customerName) {
      setValue("deliveryContactName", customerName);
    }

    if (customerPhone) {
      // Copy the formatted phone value and validation state
      setDeliveryPhoneValue(customerPhone);
      setDeliveryPhoneValidationError("");
      setIsDeliveryPhoneValid(isPhoneValid);

      // Set the normalized phone number in the form
      const normalizedPhone = normalizePhoneNumber(customerPhone);
      setValue("deliveryContactPhoneNumber", normalizedPhone);
    }

    // Show success message
    // toast.success("Customer details copied to delivery contact!");
  };

  // Add email change handler
  const handleEmailChange = (value: string) => {
    setEmailValue(value);
    setValue("email", value);

    if (!value || value.trim() === '') {
      setEmailValidationError("");
      setIsEmailValid(true);
      return;
    }

    const validation = validateEmail(value);

    if (!validation.isValid) {
      setEmailValidationError(validation.message || "Invalid email address");
      setIsEmailValid(false);
    } else {
      setEmailValidationError("");
      setIsEmailValid(true);
    }
  };

  return (
    <>
      <div className="mb-4">
        <ControlledSelect
          label={"Order By"}
          inputName={"orderBy"}
          control={control}
          isMulti={false}
          optionsList={OrderPersonType}
          rules={{ required: true }}
          isRequired={true}
          isDisabled={!isCanChangeOrderBy}
        />
      </div>

      {orderByWatcher?.value && (
        <>
          <div className="mb-4">
            {orderByWatcher?.value === "CartPerson" ? (
              <ControlledSearch
                key={`cart-search-${searchKey}`}
                label="Cart"
                inputName={"cartPerson"}
                control={control}
                optionsList={cartOptions}
                loading={cartLoading}
                handleInputChange={handleCartInputChange}
                onChange={handleCartSelect}
                isRequired={!isNewCustomer}
                defaultValue={cartPersonWatcher || null}
                placeholder={"Search for Cart Name..."}
                isDisabled={!isCanChangeOrderBy}
              />
            ) : (
              <>
                {orderByWatcher?.value === "Organization" && (
                  <div className="mb-4">
                    <ControlledSearch
                      key={`organization-search-${searchKey}`}
                      label="Organization"
                      inputName={"organization"}
                      control={control}
                      optionsList={organizationOptions}
                      loading={loading}
                      handleInputChange={handleOrganizationInputChange}
                      onChange={handleOrganizationSelect}
                      placeholder={"Search For Organization..."}
                      isRequired={orderByWatcher?.value === "Organization"}
                      defaultValue={organizationWatcher || null}
                      hasButton={false}
                    />
                  </div>)}
                {(orderByWatcher?.value === "User" || orderByWatcher?.value === "Organization") && (
                  <>
                    {orderByWatcher?.value === "User" && (
                      <div className="mb-4">
                        <ControlledSearch
                          key={`customer-search-${searchKey}`}
                          label="Customer"
                          inputName={"user"}
                          control={control}
                          optionsList={customerOptions}
                          loading={loading}
                          placeholder={"Search Customer..."}
                          handleInputChange={handleCustomerInputChange}
                          onChange={handleUserSelect}
                          isRequired={!isNewCustomer}
                          defaultValue={customerWatcher || null}
                          hasButton={true}
                          onButtonClick={handleAddNewButtonClick}
                          isDisabled={!isCanChangeOrderBy}
                          buttonLabel={"Add New Customer"}
                        />
                      </div>
                    )}
                    {isNewCustomer && (
                      <>
                        <div className="mb-4">
                          <ControlledRowTextField
                            label={"User Name"}
                            inputName={"userName"}
                            inputType={"text"}
                            placeholder={"Customer Name"}
                            isRequired={true}
                            control={control}
                            rules={{
                              required: true,
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="mb-4 mt-4">
                      <Row>
                        <Col lg="4">
                          <Label className="mt-3">
                            Mobile Number *
                            {phoneValidationError && (
                              <div className="text-danger mt-1 small">
                                <i className="fas fa-exclamation-triangle me-1"></i>
                                {phoneValidationError}
                              </div>
                            )}
                          </Label>
                        </Col>
                        <Col className="mt-3">
                          <input
                            type="tel"
                            className={`form-control ${phoneValidationError ? 'is-invalid' : isPhoneValid ? 'is-valid' : ''} ${!isNewCustomer && customerWatcher?.phoneNumber ? 'bg-light' : ''
                              }`}
                            placeholder={
                              orderByWatcher?.value === "Organization"
                                ? "Enter Organization Contact Number (e.g., 0771234567)"
                                : isNewCustomer
                                  ? "Enter Customer Mobile Number (e.g., 0771234567)"
                                  : customerWatcher?.phoneNumber
                                    ? "Mobile Number (from customer profile)"
                                    : "Enter Customer Mobile Number (e.g., 0771234567)"
                            }
                            value={phoneValue}
                            onChange={(e) => handlePhoneNumberChange(e.target.value)}
                            onBlur={(e) => handlePhoneNumberBlur(e.target.value)}
                            disabled={!isCanChangeOrderBy}
                          />
                        </Col>
                      </Row>
                    </div>
                    {isNewCustomer && orderByWatcher?.value === "User" && (
                      <div className="mb-4">
                        <Row>
                          <Col lg="4">
                            <Label className="mt-3">
                              Email
                              {emailValidationError && (
                                <div className="text-danger mt-1 small">
                                  <i className="fas fa-exclamation-triangle me-1"></i>
                                  {emailValidationError}
                                </div>
                              )}
                            </Label>
                          </Col>
                          <Col className="mt-3">
                            <input
                              type="email"
                              className={`form-control ${emailValidationError ? 'is-invalid' : isEmailValid ? 'is-valid' : ''
                                }`}
                              placeholder="Enter Email Address (e.g., user@example.com)"
                              value={emailValue}
                              onChange={(e) => handleEmailChange(e.target.value)}
                              disabled={!isCanChangeOrderBy}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                  </>
                )}
                <div className="mb-4">
                  <Row>
                    <Col lg="4">
                      <Label className="mt-3">Order Type</Label>
                    </Col>
                    <Col className="mt-3">
                      <ControlledToggleSwitch
                        inputName="isDeliveryOrder"
                        control={control}
                        leftLabel="Pickup"
                        rightLabel="Delivery"
                        defaultValue={true}
                        isDisabled={!isCanChangeOrderBy}
                      />
                    </Col>
                  </Row>
                </div>
                {!isDeliveryOrderWatcher && (
                  <>
                    <Row className="mb-3">
                      <ControlledSelect
                        label={"Pickup Time Slot"}
                        inputName={"orderTimeSlot"}
                        control={control}
                        isMulti={false}
                        optionsList={pickupTimeSlots}
                        rules={{ required: true }}
                        isRequired={true}
                      />
                    </Row>
                  </>
                )}
                {isDeliveryOrderWatcher && (
                  <div className="mb-4">
                    <Row>
                      <Col lg="4">
                        <Label className="mt-3">
                          <span>Delivery Address *</span>
                          <br />
                          {deliveryValidation.isChecking && (
                            <span className="text-info ms-2">
                              <FontAwesomeIcon icon={faSpinner} spin className="me-1" />
                              Verifying...
                            </span>
                          )}
                        </Label>
                      </Col>
                      <Col className="mt-3">
                        <div className="delivery-address-selector">
                          {selectedAddress ? (
                            <div className="selected-address-card">
                              <div className="address-content">
                                <div className="address-header">
                                  <FontAwesomeIcon
                                    icon={faMapMarkerAlt}
                                    className="address-icon me-2"
                                  />
                                  {selectedAddress.tag && (
                                    <span className="address-tag">{selectedAddress.tag}</span>
                                  )}
                                </div>
                                <div className="address-text">
                                  {selectedAddress.address}
                                </div>
                              </div>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={handleAddressModalOpen}
                                disabled={!isCanChangeOrderBy}
                                className="change-address-btn"
                              >
                                <FontAwesomeIcon icon={faEdit} className="me-1" />
                                Change
                              </Button>
                            </div>
                          ) : (
                            <Button
                              variant="outline-secondary"
                              onClick={handleAddressModalOpen}
                              disabled={!isCanChangeOrderBy}
                              className="select-address-btn"
                            >
                              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                              Select Delivery Address
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
                {isDeliveryOrderWatcher && (
                  <>
                    <div className="mb-3">
                      <Row className="d-flex align-items-center">
                        <Col lg="4">
                          <Label className="mt-3">Delivery Contact</Label>
                        </Col>
                        <Col className="mt-3">
                          <ButtonComponent
                            onClick={handleUseCustomerDetails}
                            isDisabled={!isCanChangeOrderBy || (!phoneValue && !customerWatcher && !organizationWatcher)}
                            titel="Use Customer Details"
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="mb-4">
                      <ControlledRowTextField
                        label={"Delivery Contact Name"}
                        inputName={"deliveryContactName"}
                        inputType={"text"}
                        placeholder={"Enter Delivery Contact Name"}
                        control={control}
                      />
                    </div>
                    <div className="mb-4">
                      <Row>
                        <Col lg="4">
                          <Label className="mt-3">
                            Delivery Contact Number
                            {deliveryPhoneValidationError && (
                              <div className="text-danger mt-1 small">
                                <i className="fas fa-exclamation-triangle me-1"></i>
                                {deliveryPhoneValidationError}
                              </div>
                            )}
                          </Label>
                        </Col>
                        <Col className="mt-3">
                          <input
                            type="tel"
                            className={`form-control ${deliveryPhoneValidationError ? 'is-invalid' : isDeliveryPhoneValid ? 'is-valid' : ''
                              }`}
                            placeholder="Enter Delivery Contact Number (e.g., 0771234567)"
                            value={deliveryPhoneValue}
                            onChange={(e) => handleDeliveryPhoneNumberChange(e.target.value)}
                            onBlur={(e) => handleDeliveryPhoneNumberBlur(e.target.value)}
                            disabled={!isCanChangeOrderBy}
                          />
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
                {isDeliveryOrderWatcher && (
                  <>
                    <div className="mb-4">
                      <ControlledRowTextField
                        label={"Delivery Instructions"}
                        inputName={"deliveryInstructions"}
                        inputType={"text"}
                        placeholder={"Enter Delivery Instructions"}
                        control={control}
                      /></div>
                    <Row className="mb-3">
                      <ControlledSelect
                        label={"Delivery Time Slot"}
                        inputName={"orderTimeSlot"}
                        control={control}
                        isMulti={false}
                        optionsList={deliveryTimeSlots}
                        rules={{ required: true }}
                        isRequired={true}
                      />
                    </Row>
                    <div className="mb-4">
                      <ControlledRowTextField
                        label={"Manual Delivery Fee"}
                        inputName={"manualDeliveryFee"}
                        inputType={"number"}
                        placeholder={"Enter Manual Delivery Fee"}
                        control={control}
                        min="0"
                        step="0.01"
                        isDisabled={!watch("enableManualDeliveryFee") || !isCanChangeOrderBy}
                        hasCheckbox={true}
                        checkboxInputName={"enableManualDeliveryFee"}
                        isCheckboxDisabled={!isCanChangeOrderBy}
                        onChange={(e) => {
                          let value = e.target.value;

                          // Remove any non-numeric characters except decimal point
                          value = value.replace(/[^0-9.]/g, '');

                          // Prevent multiple decimal points
                          const decimalCount = (value.match(/\./g) || []).length;
                          if (decimalCount > 1) {
                            const parts = value.split('.');
                            value = parts[0] + '.' + parts.slice(1).join('');
                          }

                          // Prevent negative values and invalid formats
                          const numValue = parseFloat(value);
                          if (isNaN(numValue) || numValue < 0) {
                            value = "";
                          }

                          // Update the input field and form state
                          e.target.value = value;
                          setValue("manualDeliveryFee", value === "" ? undefined : parseFloat(value));
                        }}
                        rules={{
                          validate: (value: any) => {
                            // Only validate if checkbox is enabled
                            if (watch("enableManualDeliveryFee")) {
                              if (value === undefined || value === null || value === "") {
                                return "Please enter a manual delivery fee amount";
                              }
                              if (value < 0) {
                                return "Delivery fee cannot be negative";
                              }
                            }
                            return true;
                          }
                        }}
                      />
                      {/* Display real-time validation error */}
                      {manualDeliveryFeeError && enableManualDeliveryFeeWatcher && (
                        <div className="text-danger small mt-1 ms-3">
                          <i className="fas fa-exclamation-triangle"></i> {manualDeliveryFeeError}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>

          {(orderByWatcher?.value === "User" || orderByWatcher?.value === "Organization") && !isDeliveryOrderWatcher && (
            <div className="mb-4">
              <ControlledSearch
                key={`user-cart-search-${searchKey}`}
                label="Cart"
                inputName={"cart"}
                control={control}
                optionsList={cartOptions}
                loading={cartLoading}
                handleInputChange={handleCartInputChange}
                onChange={handleCartSelect}
                isRequired={true}
                defaultValue={cartPersonWatcher || null}
                placeholder={"Search for Cart Name..."}
                isDisabled={!isCanChangeOrderBy}
              />
            </div>
          )}
        </>
      )}
      <div className="mb-4">
        <ControlledRowTextField
          label={"Order Note"}
          inputName={"orderNote"}
          inputType={"text"}
          placeholder={"Enter Order Note"}
          control={control}
        />
      </div>
      <div className="mb-4">
        <ControlledRowTextField
          label={"Packing Note"}
          inputName={"packingNote"}
          inputType={"text"}
          placeholder={"Enter Packing Note"}
          control={control}
        />
      </div>
      <div className="mb-4">
        <ControlledRowTextField
          label={"Payment Note"}
          inputName={"paymentNote"}
          inputType={"text"}
          placeholder={"Enter Payment Note"}
          control={control}
        />
      </div>
      {/* Manual Discount Type Dropdown */}
      {watch("enableManualDiscount") && (
        <div className="mb-4">
          <ControlledSelect
            label={"Manual Discount Type"}
            inputName={"manualDiscountType"}
            control={control}
            isMulti={false}
            optionsList={[
              { label: "Fixed", value: "Fixed" },
              { label: "Percentage", value: "Percentage" }
            ]}
            placeholder={"Select Discount Type"}
            isDisabled={!isCanChangeOrderBy}
            isClear={false}
          />
        </div>
      )}
      <div className="mb-4">
        <ControlledRowTextField
          label={"Manual Discount"}
          inputName={"manualDiscount"}
          inputType={"number"}
          placeholder={watch("manualDiscountType")?.value === "Percentage" ? "Enter percentage (max 100)" : "Enter Manual Discount"}
          control={control}
          min="0"
          max={watch("manualDiscountType")?.value === "Percentage" ? "100" : undefined}
          step="0.01"
          isDisabled={!watch("enableManualDiscount") || !isCanChangeOrderBy}
          hasCheckbox={true}
          checkboxInputName={"enableManualDiscount"}
          isCheckboxDisabled={!isCanChangeOrderBy}
          onChange={(e) => {
            let value = e.target.value;

            // Remove any non-numeric characters except decimal point
            value = value.replace(/[^0-9.]/g, '');

            // Prevent multiple decimal points
            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1) {
              value = value.substring(0, value.lastIndexOf('.'));
            }

            // Prevent negative values and invalid formats
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue < 0) {
              return;
            }

            // Check if discount type is percentage and limit to 100
            const discountType = watch("manualDiscountType")?.value;
            if (discountType === "Percentage" && numValue > 100) {
              value = "100";
            }

            // Update the input field and form state
            e.target.value = value;
            setValue("manualDiscount", value === "" ? undefined : parseFloat(value));
          }}
          rules={{
            validate: (value: any) => {
              // Only validate if checkbox is enabled
              if (watch("enableManualDiscount")) {
                if (value === undefined || value === null || value === "") {
                  return "Please enter a manual discount amount";
                }
                if (value < 0) {
                  return "Discount cannot be negative";
                }
                // Check percentage validation
                const discountType = watch("manualDiscountType")?.value;
                if (discountType === "Percentage" && value > 100) {
                  return "Percentage discount cannot exceed 100%";
                }
              }
              return true;
            }
          }}
        />
        {/* Display real-time validation error */}
        {manualDiscountError && enableManualDiscountWatcher && (
          <div className="text-danger small mt-1 ms-3">
            <i className="fas fa-exclamation-triangle"></i> {manualDiscountError}
          </div>
        )}
      </div>

      <div className="mb-2">
        <ControlledSelect
          label={"Payment Method"}
          inputName={"paymentMethod"}
          isRequired={true}
          control={control}
          isMulti={false}
          optionsList={PaymentMethod.filter((method) => {
            if (method.value === "CardOnDelivery") {
              return (
                orderByWatcher?.value === "User" ||
                orderByWatcher?.value === "Organization"
              );
            }
            if (method.value === "BankTransfer") {
              return orderByWatcher?.value !== "CartPerson";
            }
            if (method.value === "Credit") {
              return orderByWatcher?.value === "Organization";
            }
            return true;
          }).map((method) => {
            if (method.value === "CardOnDelivery" && !isDeliveryOrderWatcher) {
              return { ...method, label: "Card On Pickup" };
            }
            return method;
          })}
          rules={{ required: true }}
        />
      </div>
      {/* Hide Promo Code when Manual Discount is enabled */}
      {!watch("enableManualDiscount") && (
        <div className="mb-2">
          <ControlledSelect
            label={"Promotion Code"}
            inputName={"promotionCode"}
            control={control}
            isMulti={false}
            optionsList={promotionOptions}
            isLoading={promotionLoading}
            placeholder={"Select Promotion Code (Optional)"}
            isClear={true}
          />
        </div>
      )}
      {/* Add OnlinePayment input field here */}
      {orderByWatcher.value !== "CartPerson" && paymentMethodWatcher?.value === "BankTransfer" && (
        <div className="mb-4">
          <ControlledRowTextField
            label={"Online Payment Reference"}
            inputName={"onlinePaymentReference"}
            inputType={"text"}
            placeholder={"Enter Online Payment Reference"}
            control={control}
          />
        </div>
      )}

      <Row>
        <Col lg="4">
          <Label className="mt-3">Tentative Order</Label>
        </Col>
        <Col className="mt-3">
          <ControlledCheckBoxField
            label={""}
            inputName={"isTentativeOrder"}
            control={control}
            isDisabled={!isCanChangeOrderBy}
          />
        </Col>
      </Row>

      <Row>
        <Col lg="4">
          <Label
            className="mt-3"
            style={{
              color: "inherit",
              cursor: "inherit"
            }}
          >
            Schedule Order
          </Label>
        </Col>
        <Col className="mt-3">
          <ControlledCheckBoxField
            label={""}
            inputName={"isScheduledOrder"}
            control={control}
          // isDisabled={!isCanChangeOrderBy || isTentativeOrder}
          />
        </Col>
      </Row>

      {/* {scheduledOrderWatcher && !isTentativeOrder && ( */}
      {scheduledOrderWatcher && (
        <div>
          <Row className="mb-4">
            <Col lg="4">
              <Label className="mt-4">Order Date *</Label>
            </Col>
            <Col>
              <ControlledDateSelector
                label={""}
                inputName={"date"}
                control={control}
                placeHolder={"Order Date"}
                isRequired={true}
                minDate={(() => {
                  const tomorrow = new Date();
                  tomorrow.setDate(tomorrow.getDate() + 1);
                  tomorrow.setHours(0, 0, 0, 0);
                  return tomorrow;
                })()}
                rules={{ required: true }}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <ControlledSelect
              label={"Order Time Slot"}
              inputName={"orderTimeSlot"}
              control={control}
              isMulti={false}
              optionsList={deliveryTimeSlots}
              rules={{ required: true }}
              defaultSelectedValue={deliveryTimeSlots.find(slot => slot.value === "12:30-13:00")}
              isRequired={true}
            />
          </Row>
        </div>
      )}
      <DeliveryAddressModal
        show={showAddressModal}
        onHide={handleAddressModalClose}
        addresses={savedAddresses}
        onSelect={handleAddressSelect}
        isLoadingAddresses={isLoadingCustomerAddresses}
      />
    </>
  );
};

export default CartPersonDetailsStep;